type AxiosLikeError = {
  code?: string;
  response?: {
    status?: number;
  };
};

export const shouldRetryRequest = (failureCount: number, error: unknown): boolean => {
  if (failureCount >= 3) return false;

  const axiosError = error as AxiosLikeError;

  if (axiosError.response?.status) {
    const status = axiosError.response.status;

    if (status >= 400 && status < 500) {
      if (status === 408) return true;
      return false;
    }

    if (status >= 500) {
      if (status === 502 || status === 503 || status === 504) {
        return true;
      }
      return false;
    }
  }

  const isConnectionError =
    axiosError.code === 'ECONNRESET' ||
    axiosError.code === 'ECONNABORTED' ||
    axiosError.code === 'ETIMEDOUT' ||
    axiosError.code === 'ERR_NETWORK';

  return isConnectionError;
};

export const getRetryDelay = (attemptIndex: number): number => {
  return Math.min(1000 * 2 ** attemptIndex, 30000);
};

export const DEFAULT_QUERY_OPTIONS = {
  retry: shouldRetryRequest,
  retryDelay: getRetryDelay,
} as const;
